import {
  BattlecardsOfferingRequest,
  BattlecardsOfferingResponse,
  BattlecardsOperator,
  BattlecardsRecommendedOffering,
  BattlecardsServiceCategory,
  InternalOfferingsVisibility,
} from '@app/support/models/battlecards/battlecards.model';

export class BattlecardsGetOperatorsAction {
  static readonly type = '[API Battlecards] Get operators';
}

export class BattlecardsGetOperatorsSuccessAction {
  static readonly type = '[API Battlecards] Get operators success';
  constructor(public operators: BattlecardsOperator[]) {}
}

export class BattlecardsGetOperatorsFailedAction {
  static readonly type = '[API Battlecards] Get operators failed';
  constructor(public error: string) {}
}

export class BattlecardsGetExternalOfferingsAction {
  static readonly type = '[API Battlecards] Get external offerings';
  constructor(public params: BattlecardsOfferingRequest) {}
}

export class BattlecardsGetExternalOfferingsSuccessAction {
  static readonly type = '[API Battlecards] Get external offerings success';
  constructor(public response: BattlecardsOfferingResponse) {}
}

export class BattlecardsGetExternalOfferingsFailedAction {
  static readonly type = '[API Battlecards] Get external offerings failed';
  constructor(public error: string) {}
}

export class BattlecardsAppendExternalOfferingsAction {
  static readonly type = '[API Battlecards] Append external offerings';
}

export class BattlecardsAppendExternalOfferingsSuccessAction {
  static readonly type = '[API Battlecards] Append external offerings success';
  constructor(
    public response: BattlecardsOfferingResponse,
    public params: BattlecardsOfferingRequest
  ) {}
}

export class BattlecardsAppendExternalOfferingsFailedAction {
  static readonly type = '[API Battlecards] Append external offerings failed';
}

export class BattlecardsGetInternalOfferingsAction {
  static readonly type = '[API Battlecards] Get internal offerings';
  constructor(public params: BattlecardsOfferingRequest) {}
}

export class BattlecardsGetInternalOfferingsSuccessAction {
  static readonly type = '[API Battlecards] Get internal offerings success';
  constructor(public response: BattlecardsOfferingResponse) {}
}

export class BattlecardsGetInternalOfferingsFailedAction {
  static readonly type = '[API Battlecards] Get internal offerings failed';
  constructor(public error: string) {}
}

export class BattlecardsAppendInternalOfferingsAction {
  static readonly type = '[API Battlecards] Append internal offerings';
}

export class BattlecardsAppendInternalOfferingsSuccessAction {
  static readonly type = '[API Battlecards] Append internal offerings success';
  constructor(
    public response: BattlecardsOfferingResponse,
    public params: BattlecardsOfferingRequest
  ) {}
}

export class BattlecardsAppendInternalOfferingsFailedAction {
  static readonly type = '[API Battlecards] Append internal offerings failed';
  constructor(public error: string) {}
}

export class BattlecardsGetServiceCategoriesAction {
  static readonly type = '[API Battlecards] Get service categories';
}

export class BattlecardsGetServiceCategoriesSuccessAction {
  static readonly type = '[API Battlecards] Get service categories success';
  constructor(public serviceCategories: BattlecardsServiceCategory[]) {}
}

export class BattlecardsGetServiceCategoriesFailedAction {
  static readonly type = '[API Battlecards] Get service categories failed';
}

export class BattlecardsGetRecommendedOfferingsAction {
  static readonly type = '[API Battlecards] Get recommended offerings';
  constructor(public offeringId: string) {}
}

export class BattlecardsGetRecommendedOfferingsSuccessAction {
  static readonly type = '[API Battlecards] Get recommended offerings success';
  constructor(public recommendedOfferings: BattlecardsRecommendedOffering[]) {}
}

export class BattlecardsGetRecommendedOfferingsFailedAction {
  static readonly type = '[API Battlecards] Get recommended offerings failed';
}

export class BattlecardsResetRecommendedOfferingsAction {
  static readonly type = '[API Battlecards] Reset recommended offerings';
}

export class BattlecardsSetInternalOfferingsVisibilityAction {
  static readonly type = '[API Battlecards] Set internal offerings visibility';
  constructor(public visibility: InternalOfferingsVisibility) {}
}
